import { lazy } from "react";

export const EmployeePage = lazy(() =>
  import("./employee").then((module) => ({
    default: module.EmployeePage,
  })),
);

export const EmployeesPage = lazy(() =>
  import("./employees").then((module) => ({
    default: module.EmployeesPage,
  })),
);

export const NotificationsPage = lazy(() =>
  import("./notifications").then((module) => ({
    default: module.NotificationsPage,
  })),
);

export const RequestPage = lazy(() =>
  import("./request").then((module) => ({
    default: module.RequestPage,
  })),
);

export const RequestsPage = lazy(() =>
  import("./requests").then((module) => ({
    default: module.RequestsPage,
  })),
);

export const ProjectCodesPage = lazy(() =>
  import("./project-codes").then((module) => ({
    default: module.ProjectCodesPage,
  })),
);

export const PerformanceReviewsPage = lazy(() =>
  import("./performance-reviews").then((module) => ({
    default: module.PerformanceReviewsPage,
  })),
);

export const TimesheetAdminPage = lazy(() =>
  import("./timesheet").then((module) => ({
    default: module.TimesheetAdminPage,
  })),
);

export const PerformanceReviewPage = lazy(() =>
  import("./performance-review").then((module) => ({
    default: module.PerformanceReviewPage,
  })),
);
